<template>
	<div class="lmDetail" >
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>产品详情</span>
			<span></span>
		</div>
		<!-- 商品头部信息 -->
		<div class="lmDetail-header">
			<div class="swiper">
				<van-swipe :autoplay="2000" @change="onChange">
					<van-swipe-item v-for="item in list.slider_image">
						<img @click="getImg(list.slider_image)" :src="item | handleUrl" alt="">
					</van-swipe-item>
					<div class="custom-indicator" slot="indicator">
						{{current + 1}}/{{list.slider_image.length}}
					</div>
				</van-swipe>
			</div>
			<div class="swiper-bottom" :style="tips">
				<div class="swiper-bottom-left">
					<div>抢购价</div>
					<div>
						<div>¥</div>
						<div>{{list.select.total}}</div>
						<div class="tags">vip专享¥{{list.select.vip_total}}</div>
					</div>
				</div>
				<div class="swiper-bottom-right">
					<div>距离下架</div>
					<count-down class="time" :startTime="list.current_time" :endTime="list.limit_end_limit_time | toNumber" :dayTxt="'天'"
					 :hourTxt="':'" :minutesTxt="':'" :secondsTxt="''"></count-down>
				</div>
			</div>
			<div class="lmDetail-header-title">
				<div>
					<span>{{list.title}}</span>
					<span>仅剩{{list.select.goods_stuck}}件</span>
				</div>

			</div>
		</div>
		<!-- 商品参数详情 -->
		<div class="lmDetail-main">
			<div class="lmDetail-main-vip" v-if="vip_state==0" @click="toMin">
				<div>
					<img src="../../assets/vip.png" alt="">
					<div>开通会员，每件立省{{Math.round(list.select.total - list.select.vip_total)}}元</div>
				</div>

				<div class="btn">立即开通</div>
			</div>

			<div class="lmDetail-main-vip-bottom"></div>

			<div class="lmDetail-main-tag">
				<div>
					<van-icon name="passed" />
					<span>正品保证</span>
				</div>
				<div>
					<van-icon name="passed" />
					<span>厂家直销</span>
				</div>
				<div>
					<van-icon name="passed" />
					<span>全国联保</span>
				</div>
				<div>
					<van-icon name="passed" />
					<span>24h上门服务</span>
				</div>
			</div>
			<div class="lmDetail-main-norms">
				<van-cell is-link @click="onClickButton(1)">
					<div slot="title">
						<span>已选&nbsp;</span>
						<span>{{list.goods_spec_combination[0].goods_spec_name}}</span>
					</div>
				</van-cell>
				<van-cell is-link @click="param=true">
					<div slot="title">
						<span>参数&nbsp;</span>
						<span>{{list.goods_brand}}</span>
					</div>
				</van-cell>
			</div>
			<!-- 评价 -->
			<div class="discuss">
				<div class="title" @click="toComment">
					<div>
						<span class="special-span">评价</span>
						<span class="special-num" v-if="userList.length === 0">共0条评论</span>
						<span class="special-num" v-else>共{{userList.count.count}}+条评论</span>
					</div>
					<div>
						<span v-if="userList.length == 0">好评度100%</span>
						<span v-else>好评度{{userList.count.hot_num}}%</span>
						<van-icon name="arrow" color="#F1452F" />
					</div>
				</div>
				<div class="main_null" v-if="userList.length === 0">
					暂无评价
				</div>
				<div class="main" v-else>
					<div class="list" v-for="item in userList.data">
						<div class="user">
							<img src="../../assets/touxiang.png" alt="" v-if="item.anonymous == 0">
							<img src="../../assets/user.png" alt="" v-else-if="item.user.image == undefined">
							<img :src="item.user.image | handleUrl" alt="" v-else>
							<div class="user_name">
								<span class="user-span" v-if="item.anonymous == 0">匿名</span>
								<span class="user-span" v-else>{{item.user.username}}</span>
							</div>
							<div class="time">{{item.create_time}}</div>
						</div>
						<div class="user-msg">{{item.content}}</div>
						<div class="user_img">
							<img :src="items | handleUrl" alt="" v-for="items in item.image">
						</div>
					</div>
				</div>
				<div class="see">
					<van-button round size="mini" style="padding:0 1rem" type="default" @click="toLimit">我要评论</van-button>
					<van-button round size="mini" style="padding:0 0.5rem" plain color="#F1452F" @click="toComment">查看全部评价
					</van-button>
				</div>
			</div>
		</div>
		<van-divider :style="{ color: '#000', borderColor: '#e0e0e0', padding: '0 16px' }">商品详情</van-divider>
		<!-- 推荐商品 -->
		<div v-if="fineList.length != 0">
			<div class="lmDetail-hot">
				<div class="lmDetail-hot-header">
					<img src="../../assets/xsg.png" alt="">
					<div>为您推荐</div>
				</div>
			</div>
			<div class="lmDetail-hot-list">
				<div v-for="item in fineList">
					<img :src="item.image | handleUrl" alt="">
					<div>{{item.title}}</div>
					<div>
						<span style="transform:scale(0.7)">¥</span><span>{{item.price}}</span>
						<div class="tags">vip专享¥ {{Math.round(item.vip_price)}}</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 图文介绍 -->
		<div class="detail-img" ref="richText" v-html='list.content'></div>
		<van-divider :style="{ color: '#000', borderColor: '#e0e0e0', padding: '0 16px' }">售后服务</van-divider>
		<div class="serve" v-html="list.server_info"></div>
		<!-- 底部商品导航 -->
		<van-goods-action>
			<router-link to="/home">
				<van-goods-action-icon icon="wap-home-o" text="首页" />
			</router-link>
			<!-- @click="open53" -->
			<van-goods-action-icon icon="service-o">
				<div @click="open53">客服</div>
			</van-goods-action-icon>
			<van-goods-action-button color="#f1452f" @click="onClickButton(2)" text="立即抢购" />
		</van-goods-action>
		<!-- 已选弹框 -->
		<van-popup class="select" v-model="select" position="bottom" :style="{ 'max-height': '80%' }">
			<div class="title">
				<img @click="getImg(list.select.goods_image)" :src="list.select.goods_image | handleUrl" alt="">
				<div>
					<div>
						<span>共</span>
						<span class="select-span select-blod">¥{{list.select.total}}</span>
						<span>会员尊享</span>
						<span class="select-span select-blod">¥{{list.select.vip_total}}</span>
					</div>
					<div>
						<span>剩余:</span>
						<span>{{list.select.goods_stuck}}</span>
					</div>
				</div>
				<van-icon name="cross" color="#fff" size="0.7rem" @click="select=false" />
			</div>
			<div class="main">
				<div class="lable">选择尺寸</div>
				<div class="main_size">
					<button @click="getPrice($event, index)" :class="{active : index==sizeIndex && item.goods_stuck>0,disabled: item.goods_stuck <= 0}"
					 :disabled="item.goods_stuck <= 0" v-for="(item, index) in list.goods_spec_combination">{{item.goods_spec_name}}</button>
				</div>
				<div class="number">
					<span>购买数量</span>
					<van-stepper v-model="value" button-size="1.1rem" />
				</div>
			</div>
			<div class="btn">
				<button v-if="complete" class="btn-pay" @click="confirm">确定</button>
				<button v-else class="btn-pay" @click="select=false">完成</button>
			</div>
		</van-popup>
		<!-- 参数弹框 -->
		<van-popup class="param" v-model="param" position="bottom" :style="{ 'max-height': '70%' }">
			<div class="head">产品参数</div>
			<div class="list">
				<div class="list-title">品牌</div>
				<div class="list-value">{{list.goods_brand}}</div>
			</div>
			<div class="list">
				<div class="list-title">货号</div>
				<div class="list-value">{{list.goods_number}}</div>
			</div>
			<div class="list">
				<div class="list-title">工期</div>
				<div class="list-value" v-if="list.goods_work == 7">7-10天</div>
				<div class="list-value" v-if="list.goods_work == 15">15-20天</div>
				<div class="list-value" v-if="list.goods_work == 30">30-40天</div>
			</div>
			<div class="list list_combination">
				<div class="list-title">规格</div>
				<div class="list-value">
					<div v-for="item in list.goods_spec_combination">{{item.goods_spec_name}}</div>
				</div>
			</div>
			<div class="list" v-if="list.place != ''">
				<div class="list-title">产地</div>
				<div class="list-value">{{list.place}}</div>
			</div>
			<div class="list" v-if="list.material != ''">
				<div class="list-title">材质</div>
				<div class="list-value">{{list.material}}</div>
			</div>
			<div class="list" v-if="list.dz != ''">
				<div class="list-title">定制</div>
				<div class="list-value" v-if="list.dz === 0">定制</div>
				<div class="list-value" v-if="list.dz === 1">非定制</div>
			</div>
			<div class="param_btn">
				<button @click="param=false">完成</button>
			</div>
		</van-popup>
		<!--登录 -->
		<van-popup v-model="isLogin" position="bottom" :style="{ height: '100%', 'border-radius': '0', padding: '0' }">
			<div class="close-icon" @click="isLogin=false">关闭</div>
			<Login :url="url" @clos="getClos"></Login>
		</van-popup>
		<!-- 开通会员 -->
		<van-popup v-model="show" position="bottom">
			<van-panel class="payment">
				<div slot="header" class="payment_header">
					<div class="header-type" :class="{'active': payType == 1}" @click="payType=1">
						<div>包年VIP</div>
						<div>¥680/年</div>
						<van-icon name="checked" size="1rem" v-if="payType == 1" color="#F1452F" />
					</div>
					<div class="header-type" :class="{'active': payType == 2}" @click="payType=2">
						<div>包月VIP</div>
						<div>¥88/月</div>
						<van-icon name="checked" size="1rem" v-if="payType == 2" color="#F1452F" />
					</div>
				</div>
				<div class="payment_content">
					<van-radio-group v-model="radio">
						<van-cell-group>
							<van-cell title="微信支付" clickable @click="radio='1'">
								<div slot="icon" class="payment_icon">
									<img src="../../assets/wx.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="1" />
							</van-cell>
							<van-cell title="支付宝支付" clickable @click="radio='2'">
								<div slot="icon" class="payment_icon">
									<img src="../../assets/zfb.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="2" />
							</van-cell>
						</van-cell-group>
					</van-radio-group>
					<div class="pays_btn">
						<button @click="submitPay">确定</button>
					</div>
				</div>
			</van-panel>
		</van-popup>
		<!-- 预览图 -->
		<van-image-preview v-model="showimg" :images="image"></van-image-preview>
	</div>
</template>

<script>
	import Login from '@/components/login/login'
	import Loding from '@/components/loding'
	import CountDown from 'vue2-countdown'

	export default {
		data() {
			return {
				tips: {
					backgroundImage: "url(" + require("../../assets/qg.png") + ")"
				},
				current: 0, //轮播图指示器
				list: [], //商品信息
				fineList: [], //推荐商品
				userList: [], //评论列表
				select: false,
				param: false,
				value: 1, //购买数量
				sizeIndex: 0,
				url: '',
				complete: false,
				isLogin: false,
				vip_state: 0,
				show: false,
				radio: '1',
				payType: 1,
				showimg: false,
			}
		},
		components: {
			Login,
			Loding,
			CountDown
		},
		created() {
			//会员信息
			this.$axios.post(baseUrl + '/mobile/User/userInformation', {
				token: localStorage.getItem('Authorization')
			}).then((res) => {
				if (res.data.code == 2) {
					this.vip_state = res.data.data.vip_state
				}
			}).catch((err) => {
				console.log(err);
			});
			//详情信息
			this.$axios.post(baseUrl + '/mobile/Limit_Goods/limitGoodsInfo', {
				id: this.$route.query.id
			}).then((res) => {
				if (res.data.code == 2) {
					console.log(res)
					this.list = res.data.data;
					this.changeSize(this.list.goods_spec_combination[0].id);
					//精品推荐
					this.$axios.post(baseUrl + '/mobile/Base/goodsRecommend', {
						category_id: this.$route.query.cart_id,
						limit: 10
					}).then((res) => {
						console.log(res)
						if (res.data.code == 2) {
							this.fineList = res.data.data;
						}
					}).catch((err) => {
						console.log(err);
					});
					//获取评论
					this.$axios.post(baseUrl + '/mobile/Goods/goodsComment', {
						id: this.$route.query.id,
						page: 1,
						limit: 2
					}).then((res) => {
						if (res.data.code == 2) {
							this.userList = res.data;
						} else {
							this.userList = [];
						}
					}).catch((err) => {
						console.log(err);
					});
				} else {
					this.$toast(res.data.msg);
					setTimeout(() => {
						this.back();
					}, 1000)
				}
			}).catch((err) => {
				console.log(err);
			});
			// 上传浏览记录
			if (localStorage.getItem('Authorization') != "") {
				this.$axios.post(baseUrl + '/mobile/Base/browseAdd', {
					goods_id: this.$route.query.id,
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					console.log(res)
				}).catch((err) => {
					console.log(err);
				});
			};
		},
		mounted() {
			window.addEventListener('scroll', this.hanldScroll);
		},
		methods: {
			//确认支付
			submitPay() {
				this.$axios.post(baseUrl + '/mobile/UserVip/orderUserVip', {
					token: localStorage.getItem('Authorization'),
					is_channel: this.radio,
					vip_mode: this.payType
				}).then((res) => {
					if (res.data.code == 19) {
						if (this.radio == '1') {
							window.location.href = baseUrl + '/mobile/Pay/OrderUserVipWapWxPay?out_trade_no=' + res.data.data
							this.$router.push({
								path: '/min',
								query: {
									order_number: res.data.data
								}
							})
						} else {
							window.location.href = baseUrl + '/mobile/Pay/OrderUserVipWapPay?out_trade_no=' + res.data.data
							this.$router.push({
								path: '/min',
								query: {
									order_number: res.data.data
								}
							})
						}
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			//查看更多
			toMin() {
				this.whatLogin((bool) => {
					if (bool) {
						this.show = true;
					} else {
						this.isLogin = true;
					}
				})
			},
			//去评论
			toLimit() {
				this.whatLogin((bool) => {
					if (bool) {
						if (this.vip_state == 1) {
							this.$router.push({
								path: '/limitChain',
								query: {
									id: $route.query.id
								}
							})
						} else {
							this.$toast('您还不是会员!');
						}
					} else {
						this.isLogin = true;
					}
				})
			},
			//全部评论
			toComment() {
				this.$router.push({
					path: '/comment',
					query: {
						page: this.$route.query.id
					}
				})
			},
			//切换规格
			changeSize(ids) {
				this.$axios.post(baseUrl + '/mobile/Goods/goodsLeaseAlgorithm', {
					goods_spec_id: ids,
					category_id: this.list.category_id,
					goods_id: this.list.id
				}).then((res) => {
					if (res.data.code == 2) {
						this.$set(this.list, 'select', res.data.data);
					}
				}).catch((err) => {
					console.log(err);
				})
			},
			//轮播图change
			onChange(index) {
				this.current = index;
			},
			//点击切换已选内容
			getPrice(event, idx, lease) {
				this.sizeIndex = idx;
			},
			//立即抢购
			onClickButton(type) {
				this.whatLogin((bool) => {
					if (bool) {
						if (type == 1) {
							this.complete = false;
						} else {
							this.complete = true;
						}
						this.isLogin = false;
						this.select = true;
					} else {
						this.isLogin = true;
					}
				})
			},
			//预览图
			getImg(img) {
				if (typeof(img) == 'string') {
					this.showimg = true;
					this.image = [];
					this.image.push(baseUrl + '/uploads/' + img);
				} else {
					this.showimg = true;
					this.image = [];
					for (var i = 0; i < img.length; i++) {
						this.image.push(baseUrl + '/uploads/' + img[i]);
					}
				}
			},
			//判断是否跳转
			getClos(data) {
				this.isLogin = data;
			},
			//转确认订单
			confirm() {
				var sizeId = this.list.goods_spec_combination[this.sizeIndex].id,
					category_id = this.list.category_id,
					id = this.$route.query.id,
					value = this.value;
				if (value > this.list.select.goods_stuck) {
					this.$toast('购买数量不能超过剩余库存!');
				} else {
					this.$router.push({
						path: '/pays',
						query: {
							id: id,
							sizeId: sizeId,
							value: value,
							type: 1,
							category_id: this.list.category_id
						}
					})
				}
			}
		},
		filters: {
			'toNumber': function(value) {
				return parseInt(value);
			}
		},
		watch: {
			'sizeIndex': function(newVal) {
				this.changeSize(this.list.goods_spec_combination[newVal].id);
			},
			'$route'(to, from) {
				this.$router.go(0);
			}
		}
	}
</script>

<style scoped>
	@import 'limitDetail.css';

	.serve>>>p {
		margin: 0.8rem 0;
		color: #666 !important;
		font-size: 0.7rem !important;
		line-height: 1.5rem !important;
	}

	.detail-img>>>span {
		font-size: 0.7rem !important;
	}

	.serve>>>h4 {
		font-size: 0.8rem !important;
		color: #000 !important;
		font-weight: bold;
	}

	.serve>>>img {
		width: 95%;
		margin: auto;
		display: block;
	}

	.detail-img>>>img {
		display: block;
		width: 100%;
	}

	.detail-img>>>p {
		margin-block-start: 0em;
		margin-block-end: 0em;
	}

	.lmDetail .swiper-bottom /deep/ .time p {
		margin: 0 !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/home/limitDetail.vue